import App from "./"

export {
  App
}



// WEBPACK FOOTER //
// ./src/containers/app/koala.js